import React from 'react'
import ProjectList from './components/ProjectList/ProjectList'
import CustomBreadcrumb from '../../../../global/components/CustomBreadcrumb/CustomBreadcrumb'
import { Box, Grid } from '@mui/material'
import CustomPageHeader from '../../../../global/components/CustomPageHeader/CustomPageHeader'
import MetaListStyles from './MetaList.styles'

const MetaProjectList = () => {
  const classes = MetaListStyles;
  const breadCrumbList = [
    { name: "Settings", link: "/setting" },
    { name: "Metadata", link: "/setting/meta-data" },
    { name: "Project" },
  ];
  function  getContent(){
    return (<ProjectList />)
  }

  const  getMetaListProject = () =>{
    return(<>
    <CustomBreadcrumb breadCrumbList={breadCrumbList} />
    <Box  sx={classes.metaDatListaWrapper} >
          <CustomPageHeader
            heading="Project List"
            subInfo="Manage your Project list here"
          />
          <Grid container>
            <Grid item xs={12}>
              {getContent()}
            </Grid>
          </Grid>
        </Box>
    </>)
  }
return getMetaListProject()

}

export default MetaProjectList
